enum LocaleIdMap {
  ENGLISH = "en-US",
  GREAT_BRITAIN = "en-GB",
  GERMAN = "de-DE",
  SINGAPORE = "en-SG"
}

export default LocaleIdMap;
